$(function () {
  $.fn.accordion = function ({ firstActive }) {
    const panels$ = $(this).find('.accordion__panel');
    const items$ = $(this).find('.accordion__item');

    items$.each(index => {
      $(items$[index]).on("click", function (item) {
        removeActiveClass();
        $(this).addClass('active');

        const panelId = item.target.dataset['panel'];
        hidePanel();
        $('#' + panelId).addClass('open');
      });
    });

    if (firstActive) {
      const firstItem = items$[0];
      const firstItemPanelId = firstItem.dataset['panel'];

      $(firstItem).addClass('active');
      $('#' + firstItemPanelId).addClass('open');
    }

    function removeActiveClass() {
      items$.each(index => {
        $(items$[index]).removeClass('active')
      })
    }

    function hidePanel() {
      panels$.each(index => {
        $(panels$[index]).removeClass('open');
      })
    }
  };
});



